import React from 'react';
import { useSelector } from 'react-redux';

import { selectMemberDetail } from 'features/member/reducer/memberDetailSlice';

import InformationTable from 'components/common/table/InformationTable';
import AbusingUserCheckbox from './abusingUserCheckbox';
import EveryWearStatusDropdown from './everyWearStatusDropdown';
import UserType from './userType';
import CommunityUserType from './communityUserType';
import AchievementBadge from './achievementBadge';
import ReferrerAccount from './referrerAccount';

import { ConnectCommunityUserStatus, ConnectUserStatus } from 'types/member';
import { InformationObject } from 'types/common/informationTable';

import * as S from './ConnectAccountInformation.styled';

interface Props {
  userId: string;
}

const ConnectInformation = ({ userId }: Props) => {
  const generalInformation = useSelector(selectMemberDetail);

  const userData = (() => {
    const {
      connectUserStatus: status = ConnectUserStatus.ACTIVE,
      connectCommunityUserStatus: communityStatus = ConnectCommunityUserStatus.ACTIVE,
      connectUserType: userType,
      connectCommunityUserType: communityUserType,
      connectUserSupplierTypes: userSupplierTypes,
      connectBlockChainWalletAddress: walletAddress,
      everyWearCreatorStatus,
      specialBadges,
      connectReferees,
    } = generalInformation;

    return {
      userId,
      status,
      communityStatus,
      userType,
      communityUserType,
      userSupplierTypes,
      walletAddress,
      everyWearCreatorStatus,
      specialBadges,
      connectReferees,
    };
  })();

  const memberInformation: InformationObject[] = [
    {
      title: 'Abusing User',
      render: <AbusingUserCheckbox {...userData} />,
    },
    {
      title: 'EveryWear Status',
      render: <EveryWearStatusDropdown {...userData} />,
    },
    {
      title: 'User Type',
      render: <UserType {...userData} />,
    },
    {
      title: 'Community User Type',
      render: <CommunityUserType {...userData} />,
    },
    {
      title: 'Achievement Badge',
      render: <AchievementBadge userId={userId} specialBadges={userData.specialBadges} />,
    },
    {
      title: 'Referral Account',
      render: <ReferrerAccount referrers={userData.connectReferees} />,
    },
    {
      title: 'Wallet Public Key',
      render: userData.walletAddress,
    },
  ];

  return (
    <S.ConnectAccountInformationWrapper>
      <InformationTable title={'[CONNECT] Account Information'} data={memberInformation} />
    </S.ConnectAccountInformationWrapper>
  );
};

export default ConnectInformation;
